import { Col, Divider, Form, Input, Row, Select, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useUpdateBuyerMutation } from '../../../app/api/userApiSlice';
import { getBuyerCategories } from '../../../app/store/commonSlice';
import BuyerPicUpload from '../../../components/fileUpload/BuyerPicUpload';
import Buyer from '../../../core/models/Buyer';
import ViewBuyerPhoto from './ViewBuyerPhoto';

interface IProps {
  buyer: Buyer | null;
  onSuccessfulSubmit: () => void;
  drawerVisible: boolean;
}

const EditBuyerForm = ({ buyer, onSuccessfulSubmit, drawerVisible }: IProps): JSX.Element => {
  const [updateBuyer, { isError: isUpdateBuyerError }] = useUpdateBuyerMutation();

  const [buyerProfilePic, setBuyerProfilePic] = useState<string | null>();

  const buyerCategories = useSelector(getBuyerCategories);

  const [form] = Form.useForm();

  const handleUpdateBuyer = (values: any): void => {
    let updatedBuyer: Buyer;

    if (buyer) {
      updatedBuyer = { ...buyer };
      updatedBuyer.pictureFilePath =
        buyerProfilePic === null || buyerProfilePic === undefined
          ? buyer.pictureFilePath
          : buyerProfilePic;

      Object.assign(updatedBuyer, values);
    } else {
      updatedBuyer = values;
    }

    updateBuyer(updatedBuyer)
      .unwrap()
      .then((response) => {
        notification.success({
          message: 'Update Buyer',
          description: 'Buyer updated successfully.',
        });

        onSuccessfulSubmit();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!drawerVisible) {
      form.resetFields();
    }
  }, [drawerVisible]);

  return (
    <Form
      id='updateBuyerForm'
      form={form}
      layout='vertical'
      initialValues={{
        ...buyer,
        buyerCategoryId: buyer?.buyerCategory?.id,
        uniqueIdentifierTypeId: buyer?.uniqueIdentifierType?.id,
      }}
      onFinish={handleUpdateBuyer}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name='uniqueIdentifierTypeId'
            label='NIC or Password'
            rules={[{ required: true, message: 'Required' }]}
          >
            <Select>
              <Select.Option key={1} value={1} initialValues={true}>
                NIC
              </Select.Option>
              <Select.Option key={2} value={2}>
                Passport Number
              </Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='uniqueIdentifier'
            label='NIC or Passport Number'
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder='NIC or Passport Number' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name='name' label='Name' rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder='Name' />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='phoneNumber'
            label='Phone Number'
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder='Phone Number' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name='buyerCategoryId'
            label='Buyer Category'
            rules={[{ required: true, message: 'Required' }]}
          >
            <Select>
              {buyerCategories?.map((category) => (
                <Select.Option key={category.id} value={category.id} initialValues={true}>
                  {category.category}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='email'
            label='Email Address'
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder='Email Address' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name='addressLine1'
            label='Address 1'
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder='Address Line 1' />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='addressLine2'
            label='Address 2'
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder='Address Line 2' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name='city' label='City' rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder='City' />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='postalCode'
            label='Postal Code'
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder='Postal Code' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item>
            <ViewBuyerPhoto image={buyer?.pictureFilePath ?? null} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item label='Buyer profile pic'>
            <BuyerPicUpload
              onUploadSuccess={(file) => {
                setBuyerProfilePic(file);
              }}
              fileType={''}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default EditBuyerForm;
